import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["render"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { connect } from 'react-redux';
import RewardCenterInterface from '../../api/RewardCenterInterface';
import { setOfferHistory as _setOfferHistory } from '../../state/actions/rewardCenter';
import audio from '../../utils/audio';
import { getText, TEXT_KEY } from '../../utils/localization';

var HistoryDetail = /*#__PURE__*/function (_Component) {
  _inherits(HistoryDetail, _Component);

  var _super = _createSuper(HistoryDetail);

  function HistoryDetail() {
    var _this;

    _classCallCheck(this, HistoryDetail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hasData: false,
      emailSentMessage: false
    };
    _this.onSendEmail = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offerEmailResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();
              _context.next = 3;
              return RewardCenterInterface.sendOfferEmail(_this.props.activeHistoryItem.rpid);

            case 3:
              offerEmailResponse = _context.sent;

              _this.setState({
                emailSentMessage: getText(TEXT_KEY.EMAIL_SENT_MESSAGE)
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _this;
  }

  _createClass(HistoryDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._getPlayerOfferDetails();
    }
  }, {
    key: "_getPlayerOfferDetails",
    value: function () {
      var _getPlayerOfferDetails2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var offerDetails;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                audio.onClick();
                _context2.prev = 1;
                _context2.next = 4;
                return RewardCenterInterface.getPlayerOfferDetails(this.props.activeHistoryItem.rpid);

              case 4:
                offerDetails = _context2.sent;

                if (offerDetails.expiryDate === '0000-00-00 00:00:00') {
                  offerDetails.expiryDate = getText(TEXT_KEY.NO_EXPIRY_DATE);
                } else {
                  offerDetails.expiryDate = "".concat(getText(TEXT_KEY.EXPIRES_ON), ": ").concat(offerDetails.expiryDate);
                }

                offerDetails.terms = offerDetails.terms.replace(/(?:\r\n|\r|\n)/g, '<br><br>');
                this.setState({
                  offerDetails: offerDetails,
                  hasData: true
                }); // eslint-disable-next-line no-empty

                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 10]]);
      }));

      function _getPlayerOfferDetails() {
        return _getPlayerOfferDetails2.apply(this, arguments);
      }

      return _getPlayerOfferDetails;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          additionalProps = _objectWithoutProperties(_this$props, _excluded);

      return render(_objectSpread(_objectSpread(_objectSpread({}, this.state), additionalProps), {}, {
        onSendEmail: this.onSendEmail
      }));
    }
  }]);

  return HistoryDetail;
}(Component);

export default connect(function (state) {
  return {
    history: state.rewardCenter.api.history,
    activeHistoryItem: state.rewardCenter.api.history.find(function (historyItem) {
      return historyItem.rpid === state.rewardCenter.ux.history.activeHistoryItem;
    }),
    assetBaseUrl: state.app.assetBaseUrl
  };
}, function (dispatch) {
  return {
    setOfferHistory: function setOfferHistory(offerHistory) {
      dispatch(_setOfferHistory(offerHistory));
    }
  };
})(HistoryDetail);